var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.072c0 .433-.118.866-.471 1.191l-3.883 3.574a.603.603 0 01-.823 0 .495.495 0 010-.758l3.882-3.574a.495.495 0 000-.758l-3.882-3.575a.495.495 0 010-.758.603.603 0 01.823 0l3.883 3.575c.353.216.47.65.47 1.083z",
    fill: "#466EC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.294 12.073c0 .325-.235.541-.588.541H4.588c-.353 0-.588-.216-.588-.541 0-.325.235-.542.588-.542h14.118c.353 0 .588.217.588.542z",
    fill: "#466EC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.9df8a0e3c6a1a5ece9155b8d641e05fb.svg";
export { ForwardRef as ReactComponent };